import { types } from 'mobx-state-tree';
import AdvantageModel from "./advantageModel";

const AdvantagesStore = types.model('AdvantagesStore', {
    data: types.array(AdvantageModel)
}).actions(self => ({
    add(item) {
        self.data.push({ ...item });
    }
})).views(self => ({
    getByGuid(id) {
        return self.data.find(item => item.guidStr === id);
    }
}));

export default AdvantagesStore;
